<template>
  <c-container
    padding-size="small"
    :style="{ overflow: 'auto', height: 'calc(100% - 4.8rem - 4rem)' }"
  >
    <c-button
      color="light"
      stretch
      outlined
      @click="$emit('without-template')"
    >
      New without template
    </c-button>
    <c-flex-layout>
      <template #left>
        <h2>Templates</h2>
      </template>
      <template #right>
        <div :style="{ display: 'flex' }">
          <c-button
            color="light"
            icon="plus"
            fab
            @click="$emit('add-template')"
          />
        </div>
      </template>
    </c-flex-layout>
    <div
      v-if="loadingTemplates"
    >
      <c-icon
        type="loading"
        spin
        size="28"
        :color="$colors.grey.lighten1"
      />
    </div>
    <div v-else>
      <c-card-item
        v-for="(template, idx) in templates"
        :key="idx"
        class="_item"
        show-as-card
        align-top
        :icon="template.database.icon === null ? 'file-text' : template.database.icon"
        :icon-type="template.database.icon === null ? 'internal' : 'notion'"
        size="large"
        :style="{ marginBottom: '1.6rem', position: 'relative' }"
        @click="$emit('use-template', template.id)"
      >
        <template #title>
          {{ template.name === '' ? 'Untitled' : template.name }}
          <div
            v-if="showHints"
            :style="hintStyle"
          >
            {{ idx + 1 }}
          </div>
        </template>
        <template #subTitle>
          <div :style="{ color: $colors.grey.base, fontSize: $fontSizes[3] }">
            {{ template.database.name }}
          </div>
        </template>
        <template #right>
          <div
            class="_actions"
          >
            <c-button
              fab
              icon="edit"
              color="light"
              :style="{ borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: `1px solid ${$colors.grey.lighten3}` }"
              @click.stop="$emit('edit-template', template.id)"
            />
            <c-button
              fab
              icon="delete"
              color="light"
              :style="{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }"
              @click.stop="deleteTemplate(template.id)"
            />
          </div>
        </template>
      </c-card-item>
      <c-button
        icon="plus"
        color="light"
        stretch
        :style="{ justifyContent: 'flex-start' }"
        @click="$emit('add-template')"
      >
        Add new template
      </c-button>
    </div>
  </c-container>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CCardItem from 'shared/components/CCardItem.vue';
import CContainer from 'shared/components/CContainer.vue';
import CFlexLayout from 'shared/components/CFlexLayout.vue';
import CIcon from 'shared/components/CIcon.vue';
import { TEMPLATE_SERVICE } from 'shared/constants';
import { inject } from 'vue';

export default {
  name: 'SeeTemplates',
  setup() {
    const templateService = inject(TEMPLATE_SERVICE);
    return {
      templates: templateService.getAll(),
      loadingTemplates: templateService.loading,
      templateService,
    };
  },
  emits: ['add-template', 'use-template', 'edit-template', 'without-template'],
  components: {
    CContainer,
    CButton,
    CFlexLayout,
    CIcon,
    CCardItem,
  },
  data() {
    return { showHints: false };
  },
  computed: {
    hintStyle() {
      return {
        position: 'absolute',
        left: '-1rem',
        top: '1.2rem',
        padding: '.2rem .8rem',
        borderRadius: '.4rem',
        background: 'white',
        boxShadow: 'rgba(38, 50, 56, .1) 0 0 0 1px, rgba(38, 50, 56, .1) 0 2px 4px',
      };
    },
  },
  methods: {
    async deleteTemplate(templateId) {
      await this.templateService.deleteSingle(templateId);
    },
    handleKeydown(event) {
      if (event.key === 'Meta') {
        this.showHints = true;
        return;
      }
      for (let i = 1; i <= this.templates.length; i++) {
        if (event.key === `${i}`) {
          this.$emit('use-template', this.templates[i - 1].id);
        }
      }
    },
    handleKeyup(event) {
      if (event.key === 'Meta') {
        this.showHints = false;
      }
    },
  },
  created() {
    document.addEventListener('keydown', this.handleKeydown, true);
    document.addEventListener('keyup', this.handleKeyup, true);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
};
</script>

<style scoped type="text/scss">
._item {
  ._actions {
    margin-top: .5rem;
    display: flex;
    background: white;
    border-radius: 4px;
    box-shadow: rgba(38, 50, 56, .1) 0 0 0 1px, rgba(38, 50, 56, .1) 0 2px 4px;
    opacity: 0;
    transition: opacity .3s;
  }

  &:hover {
    ._actions {
      opacity: 1;
    }
  }
}
</style>
